import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { AbstractComponent } from '@ap-angular/shared/abstract';
import { AppUtils } from '@ap-angular/shared/utils';
import { AdminService } from '@ap-angular/service/admin';
import { ProviderService } from '@ap-angular/service/provider';
import { UserService } from '@ap-angular/service/user';

@Component({
	selector: 'ap-angular-error',
	templateUrl: './error.component.html',
	styleUrls: ['./error.component.scss']
})
export class ErrorComponent extends AbstractComponent implements OnInit {

	@HostBinding('class') class = 'template';

	public isLoggedIn: boolean;

	public readonly content: string = AppUtils.footerContent(this._environment);

	constructor(
		@Inject('ENVIRONMENT') private _environment: never,
		private adminService: AdminService,
		private router: Router,
		private providerService: ProviderService,
		private userService: UserService
	) {
		super();
	}

	public ngOnInit(): void {
		this.isLoggedIn = this.userService.isLoggedIn();
	}

	public reload(): void {
		super.addSubscription(combineLatest([this.adminService.clearState$(), this.providerService.clearState$(), this.userService.clearState$()])
			.pipe(take(1))
			.subscribe(() => this.router.navigate(['/']).then())
		);
	}

	public logout(): void {
		this.userService.logout();
	}
}
